export enum Quality {
  Idle = 'idle',
  Testing = 'testing',
  Excellent = 'excellent',
  Good = 'good',
  Fair = 'fair',
  Poor = 'poor',
  Error = 'error',
}

export const isBadQuality = (q: Quality) => q === Quality.Fair || q === Quality.Poor || q === Quality.Error;
